{
  "name": "my-ample-plugin-external",
  "version": "1.0.29",
  "type": "module",
  "description": "This npm package contains files used by my plugins for amplenote",
  "dependencies": {
    "@ai-sdk/anthropic": "1.2.10",
    "@ai-sdk/fireworks": "0.2.13",
    "@ai-sdk/google": "1.2.14",
    "@ai-sdk/groq": "1.2.8",
    "@ai-sdk/openai": "1.3.21",
    "@assistant-ui/react": "0.7.65",
    "@assistant-ui/react-markdown": "0.7.16",
    "@debanjandhar12/markmap-lib": "0.17.0-mod.3",
    "@debanjandhar12/markmap-toolbar": "0.17.0-mod.3",
    "@debanjandhar12/markmap-view": "0.17.0-mod.3",
    "@duckdb/duckdb-wasm": "1.29.1-dev269.0",
    "@emoji-mart/data": "^1.2.1",
    "@emoji-mart/react": "^1.1.1",
    "@huggingface/transformers": "3.2.4",
    "@omnivore-app/api": "^1.0.4",
    "@pinecone-database/pinecone": "4.1.0",
    "@radix-ui/react-icons": "1.3.2",
    "@radix-ui/themes": "3.2.0",
    "@yiuayiu/telegram-markdown-escape": "^0.0.2-1",
    "ai": "4.3.13",
    "apache-arrow": "^20.0.0",
    "async-mutex": "0.5.0",
    "chart.js": "^4.4.3",
    "d3-svg-to-png": "^0.3.1",
    "date-fns": "^3.6.0",
    "dayjs": "1.11.13",
    "easy-web-worker": "7.0.2",
    "emoji-mart": "^5.6.0",
    "fast-dotproduct": "1.3.0",
    "fflate": "0.8.2",
    "fparser": "^3.1.0",
    "fuse.js": "7.0.0",
    "idb": "8.0.2",
    "iconv-lite": "^0.6.3",
    "lodash-es": "^4.17.21",
    "luxon": "^3.4.4",
    "markdown-it": "^14.1.0",
    "mdast-util-to-string": "4.0.0",
    "nanoid": "^5.0.7",
    "ollama-ai-provider": "1.2.0",
    "parquetjs-lite": "^0.8.7",
    "react": "18.2.0",
    "react-dom": "18.2.0",
    "react-error-boundary": "5.0.0",
    "react-string-diff": "0.2.0",
    "react-virtuoso": "4.12.5",
    "react-window": "1.8.11",
    "remark-frontmatter": "5.0.0",
    "remark-gfm": "4.0.0",
    "remark-parse": "11.0.0",
    "scheduler-polyfill": "^1.3.0",
    "stopword": "^3.1.5",
    "tributejs": "5.1.3",
    "unified": "11.0.0",
    "unist-util-visit": "5.0.0",
    "unist-util-visit-parents": "6.0.1",
    "zod": "3.23.8"
  }
}
